// extracted by mini-css-extract-plugin
module.exports = {"status":"InvoiceStatus_status__1KDK5","statusInfoPlate":"InvoiceStatus_statusInfoPlate__1Iu3t"};